/**
 * Education article TOC: mobile toggle + scroll spy active state.
 */
(function () {
  function initEducationToc(root) {
    if (!root || root.dataset.tocReady === 'true') return;
    root.dataset.tocReady = 'true';

    const toggle = root.querySelector('[data-education-toc-toggle]');
    const links = Array.from(root.querySelectorAll('[data-education-toc-link]'));
    const sections = links
      .map((link) => {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return null;
        return document.getElementById(href.slice(1));
      })
      .filter(Boolean);

    if (toggle) {
      toggle.addEventListener('click', () => {
        root.classList.toggle('is-open');
        const expanded = root.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    if (!sections.length) return;

    const updateActive = () => {
      let current = null;
      for (const section of sections) {
        const rect = section.getBoundingClientRect();
        if (rect.top < 140) current = section;
      }
      links.forEach((link) => {
        const match = current && link.getAttribute('href') === '#' + current.id;
        link.classList.toggle('is-active', Boolean(match));
      });
    };

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  }

  function boot() {
    document.querySelectorAll('[data-education-toc]').forEach(initEducationToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
